import {
  CheckboxInput,
  FormItem,
  SelectInput,
  useField,
} from '@framework/form';
import { yup } from '@framework/validation';
import { Collapse } from 'antd';
import React from 'react';
import { StyledDrawerCollapse } from '../../../../../ui/drawer/StyledDrawerCollapse';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent';
import {
  CommonOptionListConfigComponent,
  commonOptionListDirectionValidator,
  commonOptionListSeparatorValidator,
} from '../common/option-list/CommonOptionListConfigComponent';
import { SetOptionsFromVariableInput } from '../common/option-list/SetOptionsFromVariableInput';
import { WidgetOptionItemList } from '../common/option-list/WidgetOptionItemList';
import { widgetOptionArrayValidator } from '../common/option-list/validation/optionArrayValidator';
import { IMultiSelectWidget, MultiSelectKind } from './IMultiSelectWidget';

const { Panel } = Collapse;

export const multiSelectInputConfigValidator: yup.ObjectSchema<IMultiSelectWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.MultiSelect).required(),
    options: widgetOptionArrayValidator,
    kind: yup
      .string()
      .oneOfEnum(MultiSelectKind)
      .default(MultiSelectKind.Checkbox)
      .required()
      .label('Tipo'),
    layout: BaseLayoutSchema.shape({
      hideLabel: yup.boolean().required().default(false),
    })
      // Opzioni solo per checkbox
      .when('kind', ([kind]: MultiSelectKind[], schema) => {
        if (kind === MultiSelectKind.Checkbox) {
          // return schema.shape(commonOptionListConfigValidator);
          return schema.shape({
            direction: commonOptionListDirectionValidator,
            separator: commonOptionListSeparatorValidator,
          });
        }
        return schema;
      })
      .required()
      .noUnknown(),
  })
    .required()
    .noUnknown();

export interface IMultiSelectConfigComponentProps
  extends IWidgetComponentProps<IMultiSelectWidget> {}

export function MultiSelectConfigComponent(
  props: IMultiSelectConfigComponentProps,
) {
  const kindField = useField<MultiSelectKind>('kind');
  const kind = kindField.getValue();

  return (
    <StyledDrawerCollapse defaultActiveKey={['general', 'options']} ghost>
      <Panel header="Impostazioni Generali" key="general">
        <FormItem name="kind" label="Tipo">
          <SelectInput
            name="kind"
            defaultValue={MultiSelectKind.Checkbox}
            options={[
              {
                label: 'Menù a tendina',
                value: MultiSelectKind.Select,
              },
              {
                label: 'Lista di spunte',
                value: MultiSelectKind.Checkbox,
              },
            ]}
          />
        </FormItem>
        {/* Configurazioni comuni */}
        <CommonConfigComponent
          {...props}
          hideConfigPlaceholder={kind === MultiSelectKind.Checkbox}
          noConfirmation={true}
        />

        {/* //TODO spostare in comuni e prevedere la possibilità di nascondere l'etichetta per tutti gli input */}
        <FormItem name="layout.hideLabel" layout={{ removeLabelSpace: true }}>
          <CheckboxInput name="layout.hideLabel" defaultChecked={false}>
            Nascondi etichetta
          </CheckboxInput>
        </FormItem>
        {/* Configurazioni multi-select checkbox */}
        {kind === MultiSelectKind.Checkbox && (
          <CommonOptionListConfigComponent />
        )}
      </Panel>
      <Panel header="Opzioni" key="options">
        <WidgetOptionItemList name={'options'} />
        <SetOptionsFromVariableInput name="options" />
      </Panel>
    </StyledDrawerCollapse>
  );
}
